import React from 'react';
import './Footer.css'; // Create a CSS file for styling

const handleClick = () => {
    window.location.href = 'mailto:tripathirishi80@gmail.com';
};

const Footer = () => {

    const generateCustomStyle = (index) => {
        return {
            '--i': index,
            // Add other styles as needed
        };
    };

    return (
        <div className="footer">
            <div className='head-n'>
                {[...Array(16)].map((_, index) => (
                    <span key={index} style={generateCustomStyle(index + 1)}> Contact</span>
                ))}
            </div>
            <div className='head-b'>
                <h2 className='title2'>Drop me an email if you fancy a chat! Catch me on my socials if that's more your vibe. Let's connect and make the internet a bit more lively!</h2>
            </div>
            <a href="mailto:tripathirishi80@gmail.com" className="email-link">
                tripathirishi80@gmail.com
            </a>
        </div >
    );
};

export default Footer;
